import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import store from './store';
import { DatadogLogger } from './shared/helpers/datadog-logger.helper';
import { DatadogRum } from './shared/helpers/datadog-rum.helper';
import { installGetUserMediaDevToolsFallback } from './shared/helpers/getUserMedia-devtools-fallback.helper';
import { registerIncodeSdkServiceWorker } from './serviceWorkerRegistration';

installGetUserMediaDevToolsFallback();

if (
  process.env.REACT_APP_DATADOG_LOGGING_ENABLED === 'true' &&
  process.env.NODE_ENV === 'production'
) {
  DatadogLogger.Initialize(
    process.env.REACT_APP_DATADOG_TOKEN ?? '',
    process.env.REACT_APP_DATADOG_SITE ?? 'datadoghq.com',
    process.env.REACT_APP_DATADOG_SERVICE ?? 'liveness-app',
    process.env.NODE_ENV,
  );
}

if (
  process.env.REACT_APP_DATADOG_RUM_ENABLED === 'true' &&
  process.env.NODE_ENV === 'production'
) {
  DatadogRum.Initialize(
    process.env.REACT_APP_DATADOG_RUM_APP_ID ?? '',
    process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN ?? '',
    process.env.REACT_APP_DATADOG_SITE ?? 'datadoghq.com',
    process.env.REACT_APP_DATADOG_SERVICE ?? 'liveness-app',
    process.env.NODE_ENV,
    Number(process.env.REACT_APP_DATADOG_RUM_SESSION_SAMPLE_RATE ?? '0'),
    Number(process.env.REACT_APP_DATADOG_RUM_REPLAY_SAMPLE_RATE ?? '0'),
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <App />
      </CookiesProvider>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
registerIncodeSdkServiceWorker();
